export default __webpack_public_path__ + "static/media/yellow_squeeze_cut.e7ab73fa.png";